import { AxiosResponse } from 'axios';
import { DashboardDto } from '@bom-nextgen-keycloak/models';
import { axiosInstance } from '@bom-nextgen-keycloak/web/shared/util';

export const fetchDashboardSummary = (groupId: string) =>
  axiosInstance
    .get(`/dashboard`, { params: { groupId } })
    .then(({ data }: AxiosResponse<DashboardDto>) => data);
